import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { ExTable, ModalButton, TableBody, TableHead, TableRow, TableWrapper } from 'components/shared/widget'
import { PcrRun, PcrRunForm, PcrRunSearchForm } from 'entities/pcr_run'
import { useCheckCtApi, useDeletePcrRunApi, useFetchPcrRunsApi } from 'api/pcr_run'
import { pcrRunColumnInfoList, PcrRunTableData } from './pcr_run_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { SearchConditionView } from 'components/shared/search_drawer'
import { Button } from 'react-bootstrap'
import qs from 'qs'
import { FileField } from 'components/shared/input'
import { useFetchProductItemsApi } from 'api/product_item'

type Props = {
    history: H.History
}

const PcrRunsPage = (props: Props) => {
    const searchForm = useForm<PcrRunSearchForm>({ ordering: '-pcr_run_created_at', perPage: 20 })
    const listApi = useFetchPcrRunsApi(searchForm)
    const globalState = useContext(GlobalStateContext)
    const pcrRunDisplaySetting = useDisplaySetting(pcrRunColumnInfoList(searchForm), 'PcrRun')
    const deleteApi = useDeletePcrRunApi()
    const checkCtForm = useForm<PcrRunForm>({})
    const checkCtApi = useCheckCtApi()
    const productItemsApi = useFetchProductItemsApi()

    useEffect(() => {
        listApi.execute()
        productItemsApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteApi.loading)
        if (deleteApi.isSuccess()) {
            listApi.execute()
        }
    }, [deleteApi.loading])

    const handleClickRemoveFilter = (key: keyof PcrRunSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`pcr_runs?${queryParams}`)
        }
    }, [searchForm.object])

    useEffectSkipFirst(() => {
        globalState.setLoading(checkCtApi.loading)
    }, [checkCtApi.loading])

    return (
        <>
            <ContentHeader
                headerTitle="PcrRuns"
                left={
                    <>
                        <ModalButton
                            modalHeader={<div>Rawデータをアップロードしてください</div>}
                            modalBody={
                                <div>
                                    <FileField form={checkCtForm} attr="rawData" label="Rawデータ" />
                                </div>
                            }
                            openButton={<Button>CT確認</Button>}
                            submitButton={
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        checkCtApi.execute(checkCtForm)
                                    }}
                                >
                                    確認
                                </Button>
                            }
                        />
                        <Button variant="info" onClick={() => window.open('/pcr_process_logs?ordering=-pcr_run_created_at&perPage=50&page=1')}>
                            全結果ログを表示
                        </Button>
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} hiddenSearchParams={['type']} />
                    </>
                }
                right={
                    <>
                        {searchForm.object.status === 'NOT_STARTED' ? (
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    searchForm.update((f) => {
                                        delete f.status
                                    })
                                }}
                            >
                                全てのステータスを表示
                            </Button>
                        ) : (
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    searchForm.update((f) => {
                                        f.status = 'NOT_STARTED'
                                    })
                                }}
                            >
                                未実行のみを表示
                            </Button>
                        )}
                    </>
                }
            />
            <ContentBody>
                <TableWrapper>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <TableHeads displaySetting={pcrRunDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody loading={listApi.loading} columnLength={pcrRunDisplaySetting.getColumnLength() + 1}>
                            {listApi.response.results.map((pcrRun: PcrRun) => {
                                return (
                                    <TableRow key={pcrRun.id}>
                                        <PcrRunTableData
                                            pcrRun={pcrRun}
                                            displaySetting={pcrRunDisplaySetting}
                                            onClickDetail={() => {
                                                window.open(`/pcr_run/${pcrRun.id}/`, '_blank')
                                            }}
                                            productItems={productItemsApi.response.results}
                                        />
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={listApi.pageSet} response={listApi.response} searchForm={searchForm}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(PcrRunsPage)
